<div class="section-header">
  <h4 class="section-title">
    @if (collapsible) {
      <button type="button" class="section-toggle"
        [class.expanded]="expanded"
        [attr.aria-expanded]="expanded"
        [attr.aria-controls]="bodyId"
        (click)="toggle()">
        <mat-icon class="section-toggle-icon" aria-hidden="true">expand_more</mat-icon>
        <ng-container [ngTemplateOutlet]="label"></ng-container>
      </button>
    } @else {
      <ng-container [ngTemplateOutlet]="label"></ng-container>
    }
  </h4>

  <div class="section-actions" [hidden]="isCollapsed">
    <ng-content select="[section-actions]"></ng-content>
  </div>
</div>

<div class="section-body" [id]="bodyId" [hidden]="isCollapsed">
  <ng-content></ng-content>
</div>

<ng-template #label>
  <span class="section-heading">{{ heading }}</span>
  @if (count !== null) {
    <span class="section-count">{{ count }}</span>
  }
</ng-template>
